<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="pre1"></a><a id="page_ii"><span class="smallcaps"><span class="red">ALSO BY MIREILLE GUILIANO</span></span></a></p><a id="page_ii">
<p class="textcenter"><em>French Women for All Seasons</em></p>
<p class="textcenter"><em>French Women Don’t Get Fat</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm2_pre1.vue?541dcaae